import axios from 'axios';

import formatError from './format-error';

let refreshPromise: Promise<void> | null = null;
let consecutiveFailures = 0;
const MAX_CONSECUTIVE_FAILURES = 5;

export async function refreshCSRFToken(): Promise<void> {
  // Prevent too many consecutive failures
  if (consecutiveFailures >= MAX_CONSECUTIVE_FAILURES) {
    throw new Error('Too many CSRF refresh failures. Please refresh the page.');
  }

  if (refreshPromise) {
    try {
      await refreshPromise;
      return;
      // eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-vars
    } catch (e) {
      // If the existing promise failed, we'll try again below
      // refreshPromise will be null after the finally block
    }
  }

  refreshPromise = getCSRFToken();

  try {
    await refreshPromise;
    consecutiveFailures = 0; // Reset on success
  } finally {
    refreshPromise = null;
  }
}

async function getCSRFToken(): Promise<void> {
  try {
    // Use a clean axios instance to avoid interceptor loops
    const cleanAxios = axios.create({
      withCredentials: true,
      timeout: 10000, // 10 second timeout
    });
    await cleanAxios.get(`/api/users/get-csrf-token`);
  } catch (error) {
    consecutiveFailures++;
    const err = formatError(error);
    throw err;
  }
}
